import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgStarShine = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		filter: "url(#filter0_d_62_269)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M7.73237 2.90778C7.81104 2.64096 8.18896 2.64096 8.26763 2.90778L9.32316 6.48811C9.34995 6.57898 9.42102 6.65005 9.51189 6.67684L13.0922 7.73237C13.359 7.81104 13.359 8.18896 13.0922 8.26763L9.51189 9.32316C9.42102 9.34995 9.34995 9.42102 9.32316 9.51189L8.26763 13.0922C8.18896 13.359 7.81104 13.359 7.73237 13.0922L6.67684 9.51189C6.65005 9.42102 6.57898 9.34995 6.48811 9.32316L2.90778 8.26763C2.64096 8.18896 2.64096 7.81104 2.90778 7.73237L6.48811 6.67684C6.57898 6.65005 6.65005 6.57898 6.67684 6.48811L7.73237 2.90778Z",
			fill: "black"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
		id: "filter0_d_62_269",
		x: .707642,
		y: .70752,
		width: 14.5847,
		height: 14.585,
		filterUnits: "userSpaceOnUse",
		colorInterpolationFilters: "sRGB",
		children: [
			/* @__PURE__ */ _jsx("feFlood", {
				floodOpacity: 0,
				result: "BackgroundImageFix"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				in: "SourceAlpha",
				type: "matrix",
				values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
				result: "hardAlpha"
			}),
			/* @__PURE__ */ _jsx("feOffset", {}),
			/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
			/* @__PURE__ */ _jsx("feComposite", {
				in2: "hardAlpha",
				operator: "out"
			}),
			/* @__PURE__ */ _jsx("feColorMatrix", {
				type: "matrix",
				values: "0 0 0 0 0.748892 0 0 0 0 0.748892 0 0 0 0 0.748892 0 0 0 1 0"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in2: "BackgroundImageFix",
				result: "effect1_dropShadow_62_269"
			}),
			/* @__PURE__ */ _jsx("feBlend", {
				mode: "normal",
				in: "SourceGraphic",
				in2: "effect1_dropShadow_62_269",
				result: "shape"
			})
		]
	}) })]
});
export default SvgStarShine;
